import {useEffect, useRef} from 'react';
import type {CallFeed} from 'matrix-js-sdk/lib/webrtc/callFeed';
import {matrixService} from '../../../services/matrixService';
import {MemberAvatar} from '../components/MemberAvatar';
import type {CallAvatarSize} from '../components/CallAvatar';
import type {MatrixCallLeg} from '../model/types';

export const FeedVideo = ({feed, mirror = false, contain = false, testId}: {feed: CallFeed; mirror?: boolean; contain?: boolean; testId?: string}) => {
    const ref = useRef<HTMLVideoElement>(null);
    const stream = feed.stream;
    useEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }
        element.srcObject = stream;
        void element.play().catch(() => undefined);
        return () => {
            element.srcObject = null;
        };
    }, [stream]);
    return (
        <video
            ref={ref}
            data-testid={testId}
            className={`h-full w-full ${contain ? 'object-contain' : 'object-cover'}`}
            style={mirror ? {transform: 'scaleX(-1)'} : undefined}
            muted
            autoPlay
            playsInline
        />
    );
};

export const PeerAvatar = ({leg, size}: {leg: MatrixCallLeg; size: CallAvatarSize}) => {
    const remoteUserId = leg.identity.userId ?? '';
    const member = matrixService.getRoom(leg.roomId)?.getMember(remoteUserId);
    const name = leg.identity.name ?? member?.name ?? remoteUserId;
    return <MemberAvatar userId={remoteUserId} name={name} mxcAvatarUrl={member?.getMxcAvatarUrl()} size={size}/>;
};

export const LocalAvatar = ({size}: {size: CallAvatarSize}) => {
    const client = matrixService.getClient();
    const userId = client?.getUserId() ?? '';
    const user = userId ? client?.getUser(userId) : null;
    return <MemberAvatar userId={userId} name={user?.displayName ?? userId} mxcAvatarUrl={user?.avatarUrl} size={size}/>;
};
